import { Controller } from '@hotwired/stimulus';

export default class ScrollToTestIdontroller extends Controller {
  initialize() {
    const url = new URL(window.location.href);
    const scrollTo = url.searchParams.get('scrollTo');
    if (scrollTo) {
      this.scrollIntoViewWithOffset(`[data-testid="${scrollTo}"]`, 100);
    }
  }

  scrollIntoViewWithOffset(selector, offset) {
    const element = document.querySelector(selector);
    if (element) {
      window.scrollTo({
        behavior: 'smooth',
        top:
          element.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          offset
      });

      // Scale it up and back
      setTimeout(() => {
        element.classList.add('ClassCard-scale');
        setTimeout(() => {
          element.classList.remove('ClassCard-scale');
        }, 1000);
      }, 1000);
    }
  }
}
